import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

const RejectConfirmModal = ({ isOpen, confirmCallback, cancelCallback, initialComment = null }) => {
    const [rejectedComment, set_rejectedComment] = React.useState();

    React.useEffect(() => {
        set_rejectedComment(initialComment);
    }, [initialComment]);

    const _handleConfirm = async () => {
        confirmCallback(rejectedComment);
    };

    const _handleCancel = () => cancelCallback();

    const styles = {
        input: {
            width: 300,
        },
        button: {
            width: 75,
            padding: 5,
            margin: 'auto',
            display: 'block',
        },
        noMargin: {
            margin: 0,
        },
        label: {
            fontSize: '1rem',
        },
        outerDiv: {
            padding: '20px',
        },
    };

    return (
        <Dialog
            open={isOpen}
            onClose={_handleCancel}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <DialogActions>
                <div
                    className='modal-content'
                    style={styles.outerDiv}
                >
                    <div className='modal-body'>
                        <div className='standard-form'>
                            <div
                                className='row'
                                style={styles.noMargin}
                            >
                                <label
                                    htmlFor='rejectedComment'
                                    style={styles.label}
                                >
                                    Reason for rejection:
                                </label>
                            </div>
                            <div
                                className='row'
                                style={styles.noMargin}
                            >
                                <textarea
                                    name='Text1'
                                    cols='40'
                                    rows='5'
                                    value={rejectedComment}
                                    onChange={(event) => set_rejectedComment(event.target.value)}
                                />
                            </div>
                            <div
                                className='row'
                                style={styles.noMargin}
                            >
                                <div
                                    className='columns  small-12 large-6'
                                    style={styles.noMargin}
                                >
                                    <button
                                        type='button'
                                        className='button redButton'
                                        style={styles.button}
                                        onClick={_handleConfirm}
                                    >
                                        Reject
                                    </button>
                                </div>
                                <div
                                    className='columns  small-12 large-6'
                                    style={styles.noMargin}
                                >
                                    <button
                                        type='button'
                                        className='button hollow'
                                        style={styles.button}
                                        onClick={_handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default RejectConfirmModal;
